import { TokenKind } from "common/records/Token";
import { Nullable } from "common/types";
import { stripBasePath } from "common/helpers/Redirect";

export const getUserId = (params: { userId?: string }) => {
  const userId = parseInt(params.userId || "0");
  if (!userId) {
    throw new Error("userId is invalid");
  }
  return userId;
};

export const getOrgId = (params: { orgId?: string }) => {
  const orgId = parseInt(params.orgId || "0");
  if (!orgId) {
    throw new Error("orgId is invalid");
  }
  return orgId;
};

export const getFolderId = (request: Request): Nullable<number> => {
  const { searchParams } = new URL(request.url);

  const folderId = searchParams.get("folder_id");

  return folderId ? parseInt(folderId) || null : null;
};

export const getJobId = (params: { jobId?: string }) => {
  const jobId = parseInt(params.jobId || "0");
  if (!jobId) {
    throw new Error("jobId is invalid");
  }
  return jobId;
};

export const getEstimateId = (params: { estimateId?: string }) => {
  const estimateId = parseInt(params.estimateId || "0");
  if (!estimateId) {
    throw new Error("estimateId is invalid");
  }
  return estimateId;
};

export const getParams = (request: Request) => {
  const { searchParams } = new URL(request.url);

  const page = parseInt(searchParams.get("page") || "1");
  const per_page = parseInt(searchParams.get("per_page") || "25");
  const query = searchParams.get("query");
  const tab = searchParams.get("tab") || "";

  return { page, query, tab, per_page };
};

/**
 * Gets tokenKind from params and request to be used in loaders
 */
export const getTokenKind = (params: { tokenKind: TokenKind }) => {
  if (!params.tokenKind) {
    throw new Error("tokenKind is invalid");
  }
  return params.tokenKind;
};

/**
 * Gets orgId, page, and query from params and request to be used in loaders
 */
export const getOrgIdAndParams = ({ params, request }: { params: { orgId?: string }; request: Request }) => {
  const orgId = getOrgId(params);
  const { page, query, tab, per_page } = getParams(request);

  return { orgId, page, query, tab, per_page };
};

/**
 * Gets userId, page, and query from params and request to be used in loaders
 */
export const getUserIdAndParams = ({ params, request }: { params: { userId?: string }; request: Request }) => {
  const userId = getUserId(params);
  const { page, query, per_page } = getParams(request);

  return { userId, page, query, per_page };
};

/**
 * Removes BASE_PATH (/v2/), domain, and params from request url and returns pathname
 */
export const getPathname = (request: Request) => {
  const path = stripBasePath(new URL(request.url).pathname);

  return path.startsWith("/") ? path.slice(1) : path;
};

export const getSignedDocumentId = (params: { signedDocumentId?: string }) => {
  const signedDocumentId = parseInt(params.signedDocumentId || "0");
  if (!signedDocumentId) {
    throw new Error("signedDocumentId is invalid");
  }
  return signedDocumentId;
};
